import $ from "jquery";

export function memberLogin() {
  const $form = $("#member-login");
  if (!$form.length) {
    return;
  }

  $form.on("submit", function (e) {
    e.preventDefault();

    const $message = $(".member-login__msg");
    const $submit = $form.find('button[type="submit"]');

    $form.find(".member-login__error").remove();

    const $user = $form.find("#username");
    const $pass = $form.find("#password");
    let bool = true;

    if (!$.trim($user.val())) {
      $(
        '<span class="member-login__error text-base text-red text-opacity-80"></span>',
      )
        .text("Please enter a username")
        .insertAfter($user);
      bool = false;
    }
    if (!$.trim($pass.val())) {
      $(
        '<span class="member-login__error mt-2 text-base text-red text-opacity-80"></span>',
      )
        .text("Please enter a password")
        .insertAfter($pass);
      bool = false;
    }
    if (!bool) {
      return;
    }

    $submit.prop("disabled", true);
    $message.empty();

    $.ajax({
      url: $form.attr("action"),
      data: $form.serialize(),
      type: "POST",
      dataType: "json",
      success: function (data) {
        if (data && data.success && data.data && data.data.redirect) {
          $form.addClass("success");
          window.location.href = data.data.redirect;
          return;
        }
        const msg =
          data && data.data && data.data.message
            ? data.data.message
            : "Login failed. Please try again.";
        $message.html(msg);
        $submit.prop("disabled", false);
      },
      error: function (xhr, status) {
        let msg = "Something went wrong. Please try again.";
        if (status === "parsererror" || !xhr.responseJSON) {
          const raw = (xhr.responseText || "").trim();
          if (raw === "0" || raw === "-1") {
            msg =
              "Login request could not be processed. Please refresh and try again.";
          }
        } else if (
          xhr.responseJSON &&
          xhr.responseJSON.data &&
          xhr.responseJSON.data.message
        ) {
          msg = xhr.responseJSON.data.message;
        }
        $message.html(msg);
        $submit.prop("disabled", false);
      },
    });
  });
}
